import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.entries.js";
import FormInput from '~/components/form/TextInput.vue';
import { required, email } from 'vuelidate/lib/validators';
export default {
  name: 'LoginPanel',
  props: ['isPanel'],
  components: {
    FormInput: FormInput
  },
  data: function data() {
    return {
      email: '',
      password: '',
      name: null,
      errorMessage: null,
      logining: false
    };
  },
  validations: {
    email: {
      required: required,
      email: email
    },
    password: {
      required: required
    }
  },
  computed: {
    emailError: function emailError() {
      return this.getValidationError('email', {
        email: 'validation.email',
        required: 'validation.required'
      });
    },
    passwordError: function passwordError() {
      return this.getValidationError('password', {
        required: 'validation.required'
      });
    },
    next: function next() {
      var path = this.isPanel ? this.$route.path : this.$route.query.next;
      var redirectMap = {
        '/': '/my/feed/',
        '/learning': '/learning/my/'
      };
      return redirectMap[path] || path;
    },
    authPanelStore: function authPanelStore() {
      return useAuthPanelStore();
    },
    appStore: function appStore() {
      return useAppStore();
    }
  },
  methods: {
    getValidationError: function getValidationError(field, validations) {
      if (!this.$v[field].$dirty) return null;
      for (var _i = 0, _Object$entries = Object.entries(validations); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          validation = _Object$entries$_i[0],
          errorMessage = _Object$entries$_i[1];
        if (!this.$v[field][validation]) return this.$t(errorMessage);
      }
      return null;
    },
    changePanel: function changePanel(payload) {
      this.authPanelStore.$patch({
        direction: payload.move,
        state: payload.panel
      });
    },
    submit: function submit(event) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var form;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();
              _this.$v.$touch();
              if (!_this.$v.$invalid) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              form = {
                email: _this.email,
                password: _this.password
              };
              _this.logining = true;
              _this.$axios.post('/auth/local', form).then(function (data) {
                document.location.reload();
                // this.logining = false;
              }).catch(function (error) {
                _this.logining = false;
                var res = error.response ? error.response.data : null;
                if (!res) return;
                if (res.error == 'Error.Passport.Facebook.NoEmail') {
                  _this.errorMessage = _this.$t('login.error.noFBEmail');
                }
                if (res.wrongPassword && res.wrongPassword.length) {
                  _this.errorMessage = _this.$t('login.error.wrongPassword1');
                  var part1 = "".concat(_this.$t('login.error.wrongPassword'), " ").concat(res.wrongPassword[0].triesLeft, ".");
                  var part2 = _this.$t("login.error.willBlock.".concat(res.wrongPassword[0].nextBlock));
                  _this.errorMessage = "".concat(part1, " ").concat(part2);
                }
                if (res.blocked && res.blocked.length) {
                  var date = _this.$timeformat['dd.mm.yyyy'](res.blocked[0]);
                  var time = _this.$timeformat['hh:mm'](res.blocked[0]);
                  _this.errorMessage = "".concat(_this.$t('login.error.blocked'), " ").concat(date, " ").concat(time);
                }
                if (res.error == 'Error.Passport.Email.NotFound') {
                  _this.errorMessage = _this.$t('login.error.wrongEmail');
                }
                if (res.error == 'Error.Passport.Password.NotSet') {
                  _this.errorMessage = _this.$t('login.error.passwordNotSet');
                }
              });
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};